import React from 'react';

import Button from '@sats-group/ui-lib/react/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input';
import Text from '@sats-group/ui-lib/react/text';
import TextInput from '@sats-group/ui-lib/react/text-input';

import type { NamedFC } from 'shared/types/named-fc.types';

import Layout from 'ui/components/layout/layout';

import type { LncctCampaignCode as Props } from './lncct-campaign-code.props';

const formId = 'lncct-campaign-code-form';

const LncctCampaignCode: NamedFC<Props> = ({
  campaignCode,
  description,
  descriptionTitle,
  endpoint,
  hiddenInputs,
  layout,
  submit,
}) => (
  <Layout alignTitleLeft contentWidth="narrow" {...layout}>
    <div className="lncct-campaign-code">
      <form
        action={endpoint}
        className="lncct-campaign-code__form"
        id={formId}
        method="POST"
      >
        {hiddenInputs.map(input => (
          <HiddenInput key={input.name} {...input} />
        ))}
        <TextInput {...campaignCode} />
      </form>

      <div className="lncct-campaign-code__description">
        <Text size="small" theme="emphasis">
          {descriptionTitle}
        </Text>
        <Text>{description}</Text>
      </div>
    </div>

    <div className="lncct-campaign-code__form-submit">
      <Button form={formId} wide={true} {...submit} />
    </div>
  </Layout>
);

LncctCampaignCode.displayName = 'LncctCampaignCode';

export default LncctCampaignCode;
